import { buildPublicationUrl } from "../publications/urlBuilder.js";
import { v5 as uuidv5 } from "uuid";

export function authorNameSlug(author) {
  // Public identity is derived from the display name, never a login or User ID.
  return String(author?.name || "").trim().toLowerCase().normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "").replace(/[^\p{L}\p{N}]+/gu, "-").replace(/^-|-$/g, "");
}

export function authorSlug(author) {
  const name = authorNameSlug(author);
  if (!name) return "";
  // Deterministic public disambiguator; never expose the internal UUID/login.
  const suffix = author?.id && author.id !== "legacy"
    ? uuidv5(`surgedome:public-author:${author.id}`, uuidv5.URL).replaceAll("-", "").slice(0, 16) : "";
  return suffix ? `${name}-${suffix}` : name;
}

export function authorPath(author, publication = null) {
  const slug = authorSlug(author);
  return slug ? buildPublicationUrl({ publication, path: `/author/${encodeURIComponent(slug)}` }) : null;
}

export function normalizeArticleAuthors(article, publication = null) {
  if (article.articleAuthors?.length > 0) {
    return [...article.articleAuthors]
      .sort((left, right) => left.position - right.position)
      .map(({ author, position, role }) => ({
        id: author.id,
        name: author.name,
        slug: authorSlug(author),
        url: authorPath(author, publication),
        image: author.avatar,
        position,
        role,
        bio: author.bio
      }));
  }

  if (article.author) {
    return [{
      id: article.author.id || "legacy",
      name: article.author.name,
      slug: authorSlug(article.author),
      url: authorPath(article.author, publication),
      image: article.author.avatar,
      position: 1,
      role: null,
      bio: article.author.bio
    }];
  }

  return [];
}
